<template>
  <div>
    <!-- 4988 width 200/400 -->
    <el-popover
      placement="bottom"
      :width="180"
      trigger="hover"
      :show-arrow="false"
      :popper-class="['c-header-popper c-lang-popper header-lang-popper', theme || injectTheme || routeTheme]"
      @show="showLang = true;"
      @hide="showLang = false;"
    >
      <template #reference>
        <!-- <div :class="['flex-row items-center weight-600 fz14 lh20 text-1 cursor-pointer family-gilroy-sb', {'text-link': showLang}]">
          {{ lang }} / {{ suffix }}
          <i
            :class="{active: showLang}"
            class="icon-arrow-b ml2"
          />
        </div> -->
        <span class="icon-language inline cursor-pointer" />
      </template>
      <div class="langModal">
        <div class="lang">
          <ul>
            <template v-for="item in langs">
              <li
                v-if="!item.invisible"
                :key="item.lang"
                class="flex-row-space-between items-center"
                @click="selectLang(item, 1)"
              >
                <span>{{ item.text }}</span>
                <img v-if="lang === item.text" width="16" height="16" src="@/assets/img/hk-header/icon-check.svg" />
              </li>
            </template>
          </ul>
        </div>
        <!-- 4988 隐藏货币计价选择栏 -->
        <!-- <div class="lang">
          <ul>
            <li
              v-for="item in legals"
              :key="item.suffix"
              :class="`${suffix === item.suffix ? 'active' : ''}`"
              @click="selectLang(item, 2)"
            >
              {{ item.suffix }}
            </li>
          </ul>
        </div> -->
      </div>
    </el-popover>
  </div>
</template>

<script setup lang="ts">
import { isClient } from '@vueuse/shared';
import { useCommonStore } from '@/store/common';
import { useUserStore } from '@/store/User';
import { setLang, supportLang } from '@/lang/i18n';
import siteConfig from '@/config/site';
import { defaultLang, defaultLegalFlag } from '@/config/setup';
import { userApi } from '@/config/api';

const route = useRoute();

defineProps({
  theme: {
    type: String,
    default: ''
  }
});

const injectTheme = inject('theme');

const commonStore = useCommonStore();
const user = useUserStore();

const showLang = ref(false);

interface Lang {
  lang: string;
  prefix: string;
  suffix: string;
  text: string;
}

const langs = siteConfig.supportLanguages;
const legals = siteConfig.supportLegal;

const routeTheme = computed(() => {
  const routeProps: any = route.meta.props;

  return routeProps?.header?.theme;
});

const routeLang = route.path.split('/')[1];
const routeDefaultLang = supportLang(routeLang) ? routeLang : defaultLang;

const lang = ref('');
const suffix = ref('');
if (langs.length) {
  lang.value = siteConfig.supportLanguagesMap[routeDefaultLang].text || (langs && langs[0].text);
  commonStore.suffix = defaultLegalFlag() || (legals && legals[0].suffix);
  commonStore.prefix = siteConfig.supportLegalMap[lang.value]?.prefix || (legals && legals[0].prefix);
  suffix.value = defaultLegalFlag() || legals && legals[0].suffix;
  isClient && localStorage.setItem('legal_flag', suffix.value);
}

const selectLang = (lan: Lang, index: number) => {
  // if (lan.lang.toLocaleLowerCase() === common.suffix.toLocaleLowerCase()) return;
  if (index === 1) {
    let _lang = lan.lang.split('-')[0] + '-' + lan.lang.split('-')[1].toLocaleUpperCase();
    lang.value = lan.text;
    isClient && localStorage.setItem('lang', _lang);
    commonStore.lang = _lang;
    if (user.isLogin) localStorage.setItem('setLanguage', 'true'); // 用户设置语言
    setLang(_lang, true);
    // reload刷新可能会导致部分页面文案未刷新，先不用了
    // reload(true);
  } else {
    suffix.value = lan.suffix;
    isClient && localStorage.setItem('legal_flag', lan.suffix);
    commonStore.suffix = lan.suffix;
    commonStore.prefix = lan.prefix;
    commonStore.clearRatesTimes();
    commonStore.getRates();
  }
};

onMounted(() => {
  if (user.isLogin && localStorage.getItem('setLanguage')) {
    // 设置语言后调用接口
    userApi.setLanguage({});
    localStorage.removeItem('setLanguage');
  }
});
</script>

<style lang="scss">
.c-lang-popper.el-popper {
  margin-left: -15px !important;
  padding: 0;
}
</style>

<style lang="scss" scoped>
  .langModal {
    display: flex;
    width: 100%;
    // min-height: 200px;
    color: var(--text-1);
    .lang {
      flex: 1;
      border-right: 1px solid var(--border-divider);
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
      padding: 12px;
      &:last-child {
        border-right: 0;
      }

      li {
        padding: 16px 12px;
        cursor: pointer;
        &:hover {
          border-radius: 8px;
          background: var(--bg-fill);
        }
      }
    }
  }
  .qrcode {
    width: 240px;
    min-height: 344px;
    padding: 16px 20px 20px;
    > span {
      font-weight: 600;
      font-size: 14px;
      line-height: 22px;
    }
  }
  hr {
    border-color: var(--border-divider);
    border-top: 0;
    border-left: 0;
    border-right: 0;
    margin: 0 24px;
  }
  .useModal {
    position: relative;
    .verified {
      position: absolute;
      font-weight: 500;
      font-size: 12px;
      line-height: 18px;
      color: #03a66d;
      background: rgba(14, 203, 129, 0.12);
      border-radius: 10px 0 0 10px;
      padding: 0 4px;
      right: 0;
      top: 62px;
    }

    padding: 24px 0;
    .name {
      font-weight: 600;
      font-size: 20px;
      line-height: 30px;
    }
    p {
      padding-left: 24px;
    }
    .uid {
      background: var(--bg-fill);
      border-radius: 12px;
      margin-top: 8px;
      margin-bottom: 16px;
      margin-left: 24px;
      padding: 1px 8px;
      width: fit-content;
      display: flex;
      align-items: center;
      img {
        margin-left: 6px;
        cursor: pointer;
      }
    }
    .content {
      p {
        font-weight: 500;
        font-size: 14px;
        line-height: 48px;
        height: 48px;
        cursor: pointer;
        &:hover {
          background: var(--bg-fill);
        }
        &.active {
          position: relative;
          &::before {
            position: absolute;
            content: '';
            width: 6px;
            height: 6px;
            background: var(--warning);
            top: calc(50% - 3px);
            left: 8px;
            border-radius: 50%;
          }
        }
      }
    }
    .out {
      font-weight: 500;
      font-size: 14px;
      line-height: 22px;
      text-align: center;
      margin-top: 19px;
      cursor: pointer;
    }
  }
  .orderModal {
    padding: 8px 0;
    > p {
      font-weight: 500;
      font-size: 14px;
      line-height: 48px;
      height: 48px;
      padding-left: 24px;
      cursor: pointer;
      display: flex;
      align-items: center;
      img {
        margin-right: 16px;
      }
      &:hover {
        background: var(--bg-fill);
      }
    }
    .money {
      padding-left: 24px;
      padding-right: 24px;
      font-weight: 500;
      font-size: 12px;
      line-height: 18px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      img {
        cursor: pointer;
      }
      em {
        font-weight: 600;
        font-size: 16px;
        line-height: 24px;
        margin-right: 4px;
      }
    }
    .overview {
      display: flex;
      align-items: center;
      font-weight: 500;
      font-size: 14px;
      line-height: 48px;
      height: 48px;
      padding-left: 24px;
      img {
        margin-left: 8px;
        cursor: pointer;
      }
    }
  }

  .icon-language {
    width: 28px;
    height: 28px;
    background: url(@/assets/img/hk-header/icon-language-light.svg) center/20px 20px no-repeat;

    // &:hover {
    //   background: url(@/assets/img/svg/icon-language-hover-light.svg) center/20px 20px no-repeat;
    // }
  }

  .dark {
    .icon-language {
      background: url(@/assets/img/hk-header/icon-language-dark.svg) center/20px 20px no-repeat;

      // &:hover {
      //   background: url(@/assets/img/svg/icon-language-hover-dark.svg) 0 0/100% 100% no-repeat;
      // }
    }
  }
</style>
